<template>
  <div
    ref="optionsElem"
    :class="_class"
    @click="onClick"
  >
    <div
      class="ten-options__empty"
      v-if="!loading && empty"
    >
      <slot name="emptyTip">
        {{ emptyTip }}
      </slot>
    </div>
    <slot v-else />
    <ten-loading
      class="ten-options__loading"
      v-if="loading"
      type="block"
    />
  </div>
</template>
<script>
import domHelper from '../scripts/utils/dom-helper';
import TenLoading from '../loading';

const name = 'ten-options';
let allOptions = [];

export default {
  name,
  components: {
    TenLoading,
  },
  provide() {
    return {
      tenOptions: this,
    };
  },
  props: {
    loading: Boolean,
    empty: Boolean,
    emptyTip: {
      type: String,
      default: '暂无数据',
    },
    multiple: Boolean,
    showCheckbox: Boolean,
    showRadio: Boolean,
  },
  data() {
    return {
      focusIndex: -1,
      focused: false,
    };
  },
  computed: {
    _class() {
      return [
        'ten-options',
        {
          'ten-options--empty': this.empty,
          'ten-options--loading': this.loading,
        },
      ];
    },
  },
  created() {
    this.options = [];
    allOptions.push(this);
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside);
    this.$on('focusOptionChange', this.onFocusOptionChange);
  },
  beforeDestroy() {
    allOptions = allOptions.filter(options => options !== this);
    this.blur();
    document.removeEventListener('click', this.onClickOutside);
  },
  methods: {
    addOption(option) {
      const newOptionIndex = typeof option.optionIndex === 'undefined' ? Infinity : option.optionIndex;
      let i;
      for (i = 0; i < this.options.length; i++) {
        const optionIndex = typeof this.options[i].optionIndex === 'undefined' ? -Infinity : this.options[i].optionIndex;
        if (newOptionIndex < optionIndex) {
          i += 1;
          break;
        }
      }
      this.options.splice(i, 0, option);
    },
    removeOption(option) {
      this.options = this.options.filter(item => item !== option);
    },
    focus(index) {
      if (!this.focused) {
        allOptions.forEach((options) => {
          if (options !== this) {
            options.blur();
          }
        });
        this.focused = true;
        this.bindKeyEvent();
        if (typeof index !== 'undefined') {
          this.focusOption(index);
        }
      }
    },
    blur() {
      if (this.focused) {
        this.focused = false;
        this.unbindKeyEvent();
      }
    },
    focusOption(index) {
      const { options } = this;
      options.forEach((option, oIndex) => {
        if (oIndex !== index) {
          option.blur();
        }
      });
      if (options[index]) {
        this.focusIndex = index;
        options[index].focus();
        const { optionsElem } = this.$refs;
        const optionElem = options[index].$el;
        const optionHeight = optionElem.offsetHeight;
        const optionOffsetTop = optionElem.offsetTop;
        const optionsScrollTop = optionsElem.scrollTop;
        const optionsHeight = optionsElem.clientHeight;

        if (optionOffsetTop < optionsScrollTop) {
          optionsElem.scrollTop = optionOffsetTop;
        } else if (optionOffsetTop + optionHeight > optionsScrollTop + optionsHeight) {
          optionsElem.scrollTop = optionOffsetTop + optionHeight - optionsHeight;
        }
      }
    },
    bindKeyEvent() {
      document.addEventListener('keydown', this.onKeyDown);
    },
    unbindKeyEvent() {
      document.removeEventListener('keydown', this.onKeyDown);
    },
    onClickOutside(e) {
      if (!domHelper.contains(this.$refs.optionsElem, e.target)) {
        this.blur();
      }
    },
    onKeyDown(e) {
      const { options } = this;
      const total = options.length;
      const { keyCode } = e;
      let { focusIndex } = this;
      switch (keyCode) {
        case 13:
        case 37:
        case 39:
          // e.preventDefault();
          if (focusIndex <= total - 1 && focusIndex >= 0) {
            options[focusIndex].onKeyDown(e);
          }
          break;
        case 38: // up
          focusIndex = focusIndex <= 0 ? total - 1 : focusIndex - 1;
          this.focusOption(focusIndex);
          e.preventDefault();
          break;
        case 40: // down
          focusIndex = focusIndex >= total - 1 ? 0 : focusIndex + 1;
          this.focusOption(focusIndex);
          e.preventDefault();
          break;

        default:
          break;
      }
    },
    onClick() {
      this.focus();
    },
    onFocusOptionChange(option) {
      const { options } = this;
      const index = options.indexOf(option);
      if (index > -1) {
        this.focusOption(index);
      }
    },
  },
};
</script>
